var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "54px",
    viewBox: "0 0 50 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Car/Available") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24.98575 0 24.98575 18.3154167 0 18.3154167"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Car/Available",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#FF7800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,24.8983121 C50,11.1474293 38.8071905,0 24.9999051,0 C11.1928095,0 0,11.1474293 0,24.8983121 C0,31.3772843 2.4854783,37.2775642 6.55762584,41.707025 C13.1695065,49.4648634 23.9062719,53.5782446 24.9560839,53.9674402 C24.9572222,53.9916232 24.957981,54.0037147 24.957981,53.9989914 C24.957981,53.9989914 24.9733468,53.9933235 24.9999051,53.9836881 C25.0264635,53.9933235 25.042019,53.9989914 25.042019,53.9989914 C25.042019,54.0037147 25.0427778,53.9916232 25.0439161,53.9674402 C26.0935384,53.5782446 36.8304935,49.4648634 43.4423742,41.7068361 C47.5145217,37.2775642 50,31.3772843 50,24.8983121",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/20px/Car",
    transform: "translate(13.000000, 16.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Vehicle-Type/Standard",
    transform: "translate(-0.000000, 0.000000)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.69648804b16ca24b62ac31d651abebe4.svg";
export { ForwardRef as ReactComponent };